<div class="ab-wrapper">
  <div class="ab-card">
    <!-- Header -->
    <div class="ab-header">
      @if (userId) {
      <app-business-logo
        [tenantId]="userId"
        [label]="companyName || 'Business logo'"
        [centered]="true"
      ></app-business-logo>
      }
      <span class="ab-header__eyebrow">{{
        "APPOINTMENT_BOOKING.EYEBROW" | translate
      }}</span>
      <h2 class="ab-header__company">{{ companyName || "Sagel" }}</h2>
      <p class="ab-header__sub">
        {{ "APPOINTMENT_BOOKING.SUBTITLE" | translate }}
      </p>
    </div>

    <!-- Catalog loading -->
    @if (catalogLoading) {
    <div class="ab-state">
      <div class="spinner-border" role="status" aria-hidden="true"></div>
      <p>{{ "APPOINTMENT_BOOKING.CATALOG_LOADING" | translate }}</p>
    </div>
    }

    <!-- Catalog failed -->
    @if (catalogLoadFailed) {
    <div class="ab-state ab-state--error">
      <svg [cIcon]="icons.cilWarning" size="xl"></svg>
      <p>{{ "APPOINTMENT_BOOKING.CATALOG_FAILED" | translate }}</p>
    </div>
    }

    <!-- Empty catalog -->
    @if (catalogEmpty) {
    <div class="ab-state">
      <svg [cIcon]="icons.cilCalendar" size="xl"></svg>
      <p>{{ "APPOINTMENT_BOOKING.EMPTY" | translate }}</p>
    </div>
    }

    <!-- Booking form -->
    @if (!catalogLoading && !catalogLoadFailed && !catalogEmpty && success ===
    null) {
    <form
      class="ab-body"
      #bookingForm="ngForm"
      (ngSubmit)="onSubmit(bookingForm)"
      novalidate
    >
      <!-- Stepper -->
      <div class="ab-steps">
        <div
          class="ab-step"
          [class.ab-step--active]="currentStep === 1"
          [class.ab-step--done]="currentStep > 1"
        >
          <span class="ab-step__num">1</span>
          <span class="ab-step__label">{{
            "APPOINTMENT_BOOKING.STEP1_TITLE" | translate
          }}</span>
        </div>
        <span class="ab-step__sep"></span>
        <div class="ab-step" [class.ab-step--active]="currentStep === 2">
          <span class="ab-step__num">2</span>
          <span class="ab-step__label">{{
            "APPOINTMENT_BOOKING.STEP2_TITLE" | translate
          }}</span>
        </div>
      </div>
      <!-- ── STEP 1: service, date & time ─────────────────────────────────── -->
      @if (currentStep === 1) {
      <!-- Service -->
      <div class="ab-field">
        <label class="ab-field__label"
          >{{ "APPOINTMENT_BOOKING.SERVICE" | translate }}
          <span aria-hidden="true">*</span></label
        >
        <div class="ab-service-list">
          @for (service of catalog; track service) {
          <button
            type="button"
            class="ab-service"
            [class.ab-service--active]="selectedService?.name === service.name"
            (click)="selectService(service)"
          >
            <span class="ab-service__name">{{ service.name }}</span>
            <span class="ab-service__meta">
              <span class="ab-service__pill">{{
                "APPOINTMENT_BOOKING.DURATION_PILL"
                  | translate : { minutes: service.durationMin }
              }}</span>
              @if (service.priceText) {
              <span class="ab-service__price">{{ service.priceText }}</span>
              }
            </span>
          </button>
          }
        </div>
      </div>
      <!-- Date -->
      <div class="ab-field">
        <label class="ab-field__label">{{
          "APPOINTMENT_BOOKING.DATE" | translate
        }}</label>
        <c-date-picker
          closeOnSelect
          name="date"
          locale="en-GB"
          format="dd/MM/yyyy"
          [ngModel]="dateModel"
          [ngModelOptions]="{ standalone: true }"
          [minDate]="minDate"
          [disabledDates]="fullyClosedDates"
          [dateFilter]="dateFilter"
          (ngModelChange)="onDatePick($event)"
        ></c-date-picker>
      </div>
      <!-- Time slots (15-min increments, availability-aware) -->
      @if (selectedService) {
      <div class="ab-field">
        <label class="ab-field__label">
          {{ "APPOINTMENT_BOOKING.TIME" | translate }}
          @if (time) {
          <span class="ab-slot-ends"
            >·
            {{
              "APPOINTMENT_BOOKING.ENDS_AT" | translate : { time: endTime }
            }}</span
          >
          }
        </label>
        @if (slotsLoading) {
        <div class="ab-slots-loading">
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          {{ "APPOINTMENT_BOOKING.SLOT_CHECKING" | translate }}
        </div>
        } @if (!slotsLoading && slotsUnavailable) {
        <p class="ab-slots-empty">
          {{ "APPOINTMENT_BOOKING.NO_SLOTS" | translate }}
        </p>
        } @if (!slotsLoading && daySlots.length) {
        <div class="ab-slots">
          @for (slot of daySlots; track slot) {
          <button
            type="button"
            class="ab-slot-chip"
            [class.ab-slot-chip--active]="time === slot"
            (click)="selectSlot(slot)"
          >
            {{ slot }}
          </button>
          }
        </div>
        }
      </div>
      } @if (formError) {
      <p class="ab-form-error" role="alert">{{ formError }}</p>
      }
      <button type="button" class="ab-btn-submit" (click)="nextStep()">
        {{ "APPOINTMENT_BOOKING.NEXT" | translate }}
      </button>
      }
      <!-- ── STEP 2: contact details ──────────────────────────────────────── -->
      @if (currentStep === 2) {
      <!-- Name -->
      <div class="ab-field">
        <label class="ab-field__label"
          >{{ "APPOINTMENT_BOOKING.NAME" | translate }}
          <span aria-hidden="true">*</span></label
        >
        <input
          class="ab-field__input"
          type="text"
          name="name"
          [(ngModel)]="name"
          required
          maxlength="120"
        />
      </div>
      <!-- Email + phone -->
      <div class="ab-field-row">
        <div class="ab-field">
          <label class="ab-field__label">{{
            "APPOINTMENT_BOOKING.EMAIL" | translate
          }}</label>
          <input
            class="ab-field__input"
            type="email"
            name="email"
            [(ngModel)]="email"
            autocomplete="email"
            maxlength="120"
          />
        </div>
        <div class="ab-field">
          <label class="ab-field__label">{{
            "APPOINTMENT_BOOKING.PHONE" | translate
          }}</label>
          <input
            class="ab-field__input"
            type="tel"
            name="phone"
            [(ngModel)]="phone"
            autocomplete="tel"
            maxlength="40"
          />
        </div>
      </div>
      <small class="ab-contact-rule">{{
        "APPOINTMENT_BOOKING.CONTACT_RULE" | translate
      }}</small>
      <!-- Notes -->
      <div class="ab-field">
        <label class="ab-field__label">
          {{ "APPOINTMENT_BOOKING.NOTES" | translate }}
          <span class="ab-field__optional">{{
            "APPOINTMENT_BOOKING.OPTIONAL" | translate
          }}</span>
        </label>
        <textarea
          class="ab-field__input ab-field__input--textarea"
          name="notes"
          [(ngModel)]="notes"
          rows="3"
          maxlength="500"
        ></textarea>
      </div>
      @if (formError) {
      <p class="ab-form-error" role="alert">{{ formError }}</p>
      }
      <div class="ab-nav">
        <button type="button" class="ab-btn-back" (click)="prevStep()">
          {{ "APPOINTMENT_BOOKING.BACK" | translate }}
        </button>
        <button type="submit" class="ab-btn-submit" [disabled]="isSubmitting">
          @if (isSubmitting) {
          <span
            class="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          }
          {{
            isSubmitting
              ? ("APPOINTMENT_BOOKING.SUBMITTING" | translate)
              : ("APPOINTMENT_BOOKING.SUBMIT" | translate)
          }}
        </button>
      </div>
      }
    </form>
    }

    <!-- Result -->
    @if (success !== null) {
    <div class="ab-body ab-result">
      <div
        class="ab-result__icon"
        [class.ab-result__icon--success]="success"
        [class.ab-result__icon--error]="!success"
      >
        @if (success) {
        <svg [cIcon]="icons.cilCheckCircle" size="xl"></svg>
        } @if (!success) {
        <svg [cIcon]="icons.cilXCircle" size="xl"></svg>
        }
      </div>
      <h3 class="ab-result__title">
        {{
          success
            ? ("APPOINTMENT_BOOKING.SUCCESS_TITLE" | translate)
            : ("APPOINTMENT_BOOKING.ERROR_TITLE" | translate)
        }}
      </h3>
      <p class="ab-result__message">
        {{
          success
            ? ("APPOINTMENT_BOOKING.SUCCESS_TEXT"
              | translate : { id: reservationId })
            : errorMessage || ("APPOINTMENT_BOOKING.ERROR_TEXT" | translate)
        }}
      </p>
      @if (!success) {
      <button class="ab-btn-retry" (click)="resetToForm()">
        {{ "APPOINTMENT_BOOKING.TRY_AGAIN" | translate }}
      </button>
      }
    </div>
    }

    <!-- Footer -->
    <div class="ab-footer">
      <span class="ab-footer__powered">Powered by</span>
      <img
        src="assets/img/brand/SAGEL_LOGO.svg"
        alt="Sagel"
        class="ab-footer__logo"
      />
    </div>
  </div>
</div>
